module.exports = __webpack_public_path__ + "static/media/setting-cog.d8bb2027.svg";